import { ArrowRight } from "@phosphor-icons/react";
import { Label } from "../../components/ui/label";
import { Input } from "../../components/ui/input";
import { field } from "./booking-shared";

/* ---------- Step 4: Details & contact ---------- */
export function StepDetails({ o, set }) {
  return (
    <div data-testid="step-details">
      <h2 className="font-display text-2xl text-[#4A0000]">Almost done</h2>
      <p className="text-sm text-[#5C5A58] mt-1 mb-4">Where should we send your confirmation?</p>

      <div className="grid sm:grid-cols-2 gap-3">
        <div className="sm:col-span-2"><Label className="text-xs text-[#5C5A58]">Your name</Label><Input className="mt-1 border-[#E9DDC6]" data-testid="contact-name" value={o.contact_name} onChange={(e) => set({ contact_name: e.target.value })} /></div>
        <div><Label className="text-xs text-[#5C5A58]">Email</Label><Input className="mt-1 border-[#E9DDC6]" type="email" data-testid="contact-email" value={o.contact_email} placeholder="you@email.com" onChange={(e) => set({ contact_email: e.target.value })} /></div>
        <div><Label className="text-xs text-[#5C5A58]">Phone</Label><Input className="mt-1 border-[#E9DDC6]" data-testid="contact-phone" value={o.contact_phone} onChange={(e) => set({ contact_phone: e.target.value })} /></div>
      </div>

      <details className="mt-5 group" data-testid="access-details">
        <summary className="cursor-pointer list-none flex items-center justify-between rounded-lg border border-[#E9DDC6] bg-white px-3 py-2.5 text-sm font-medium text-[#4A0000] hover:border-[#B08D57] transition">
          <span>+ Property Access Notes <span className="text-[#8A8782] font-normal">(optional — we'll confirm later)</span></span>
          <ArrowRight size={15} className="text-[#B08D57] transition-transform group-open:rotate-90" />
        </summary>
        <div className="grid sm:grid-cols-2 gap-3 mt-3">
          <div>
            <Label className="text-xs text-[#5C5A58]">Access method</Label>
            <select className={`${field} mt-1`} data-testid="access-method" value={o.access_method} onChange={(e) => set({ access_method: e.target.value })}>
              <option>Agent will meet</option><option>Lockbox</option><option>Owner home</option><option>Gate/community code</option>
            </select>
          </div>
          <div>
            <Label className="text-xs text-[#5C5A58]">Occupancy</Label>
            <select className={`${field} mt-1`} data-testid="occupancy" value={o.occupancy} onChange={(e) => set({ occupancy: e.target.value })}>
              <option>Vacant</option><option>Occupied</option><option>Staged</option>
            </select>
          </div>
          <div><Label className="text-xs text-[#5C5A58]">Pets</Label><Input className="mt-1 border-[#E9DDC6]" data-testid="pets" value={o.pets} onChange={(e) => set({ pets: e.target.value })} /></div>
          <div><Label className="text-xs text-[#5C5A58]">Gate / community code</Label><Input className="mt-1 border-[#E9DDC6]" data-testid="gate-code" value={o.gate_code} placeholder="Optional" onChange={(e) => set({ gate_code: e.target.value })} /></div>
        </div>
      </details>
    </div>
  );
}
